// extracted by mini-css-extract-plugin
export var fullGrid = "_2g-3";
export var pdpPreviewContainer = "_2g-1";
export var previewContainer = "_2g-0";
export var togglePreviewContainer = "_2g-2";